var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isIssued)?_c('a',{style:({cursor: 'pointer'}),on:{"click":function($event){return _vm.$emit('issue-pass')}}},[_c('img',{staticClass:"menu-item-img icon-pdf",attrs:{"src":_vm.iconPath('v_pass.svg'),"alt":"Выдать пропуск"}}),_vm._v(" "+_vm._s(this.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }